import { createSchema } from "@rocicorp/zero";
import { contact } from "./contact";
import { crew } from "./crew";
import { crewRelationships } from "./crew.relationships";
import { file } from "./file";
import { fileClassification } from "./file-classification";
import { fileClassificationRelationships } from "./file-classification.relationships";
import { organization } from "./organization";
import { plan } from "./plan";
import { planRelationships } from "./plan.relationships";
import { project } from "./project";
import { projectRelationships } from "./project.relationships";
import { projectMember } from "./project-member";
import { projectMemberRelationships } from "./project-member.relationships";
import { projectResourceLink } from "./project-resource-link";
import { projectResourceLinkRelationships } from "./project-resource-link.relationships";
import { resourceLink } from "./resource-link";
import { ticket } from "./ticket";
import { ticketRelationships } from "./ticket.relationships";
import { ticketAssignment } from "./ticket-assignment";
import { ticketAssignmentRelationships } from "./ticket-assignment.relationships";
import { ticketAssignmentReference } from "./ticket-assignment-reference";
import { ticketFiles } from "./ticket-files";
import { ticketFilesRelationships } from "./ticket-files.relationships";
import { organizationRelationships } from "./organization.relationships";
import { ticketType } from "./ticket-type";
import { user } from "./user";
import { userAssignment } from "./user-assignment";
import { userAssignmentRelationships } from "./user-assignment.relationships";
import { vehicle } from "./vehicle";
import { video } from "./video";
import { vehicleAssignment } from "./vehicle-assignment";
import { vehicleAssignmentRelationships } from "./vehicle-assignment.relationships";
import { vehicleAssignmentsPlan } from "./vehicle-assignment-plan";
import { vehicleAssignmentPlanRelationships } from "./vehicle-assignment-plan.relationships";
import { workspace } from "./workspace";

/**
 * The synced schema. Every name in it is the client's — the camelCase key the queries, mutators,
 * relationships and the apps read — and the database's snake_case spelling travels on `.from()`:
 * on the table, ahead of `.columns()`, where the table's name carries an uppercase letter, and
 * on every column whose key does. A table or column without `.from()` maps to its own name, so
 * a camelCase key left bare names a column the database does not have; the mutate path reports
 * that on the first write of a transaction, the query path answers with an empty result. Zero
 * hashes the server names into the client schema, so a changed `.from()` gives every browser a
 * new IndexedDB database and a full re-hydration.
 */
export const schema = createSchema({
	tables: [
		project,
		ticket,
		ticketType,
		workspace,
		contact,
		user,
		projectMember,
		plan,
		crew,
		ticketAssignment,
		ticketAssignmentReference,
		ticketFiles,
		projectResourceLink,
		resourceLink,
		file,
		fileClassification,
		organization,
		userAssignment,
		vehicleAssignment,
		vehicle,
		vehicleAssignmentsPlan,
		video,
	],
	relationships: [
		projectRelationships,
		ticketRelationships,
		projectMemberRelationships,
		planRelationships,
		crewRelationships,
		organizationRelationships,
		ticketAssignmentRelationships,
		ticketFilesRelationships,
		fileClassificationRelationships,
		projectResourceLinkRelationships,
		userAssignmentRelationships,
		vehicleAssignmentRelationships,
		vehicleAssignmentPlanRelationships,
	],
});

declare module "@rocicorp/zero" {
	interface DefaultTypes {
		schema: typeof schema;
	}
}
